import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticateserviceService } from '../../../_service/authenticateservice.service';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { URLS } from '../../../constants/URLS';
import { DeleteModalComponent } from '../../sharedComponents/delete-modal/delete-modal.component';
import { DeleteService } from 'src/app/_service/delete.service';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { Location } from '@angular/common';
import { uniqueUsernameValidator } from './unique-username.validator';

@Component({
  selector: 'app-toqqer-register',
  templateUrl: './toqqer-register.component.html',
  styleUrls: ['./toqqer-register.component.css']
})
export class ToqqerRegisterComponent implements OnInit {
  @Input() updateProfile: boolean = false;

  isLoading: boolean = false;
  formGroup: FormGroup;
  imageUrl: string | ArrayBuffer = '../../../assets/img/profile_avatar.png';
  file: any;
  userHandleError: boolean = false;
  initialFormValues: any;
  mediaUrl: any = URLS.profileImageBaseUrl;

  constructor(
    private fb: FormBuilder,
    private authService: AuthenticateserviceService,
    private http: HttpClient,
    private deleteService: DeleteService,
    private toastrService: CustomControlsService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    // this.formGroup = this.fb.group({
    //   userHandle: ['',[Validators.required,Validators.minLength(5),Validators.maxLength(20)]],
    //   screenName: ['',[Validators.required,Validators.minLength(5),Validators.maxLength(20)]],
    //   about: ['']
    // });    
    this.formGroup = this.fb.group({
      userHandle: ['',[Validators.required, Validators.minLength(5), Validators.maxLength(20), Validators.pattern(/^[a-zA-Z0-9]+$/) ],
        [
          uniqueUsernameValidator(this.http, () => this.updateProfile)
        ]
      ],
      screenName: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(20)]],
      about: ['']
    });
    
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.updateProfile = params['updateProfile'] == 'true';
      console.log(this.updateProfile);
      if (this.updateProfile) {
        this.loadProfileDetails();
      }
      this.initialFormValues = {
        screenName: this.formGroup.get('screenName')?.value,
        about: this.formGroup.get('about')?.value
      };
    });
  }

  loadProfileDetails() {
    const profileImg = localStorage.getItem('profileImage');
    this.formGroup.patchValue({
      userHandle: (localStorage.getItem('userName') || '').replace('@', ''),
      screenName: localStorage.getItem('screenName') || '',
      about: localStorage.getItem('description') || ''
    });
    if (profileImg) {
      this.imageUrl = this.mediaUrl + encodeURIComponent(profileImg);
    }
  }

  onUserHandleInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    const cursorPosition = input.selectionStart || 0;
    const needsAtPrefix = !value.startsWith('@');
    if (!value.startsWith('@')) {
      value = '@' + value;
    }
    value = '@' + value.substring(1).replace(/@/g, '');
    input.value = value;
    const actualValue = value.substring(1);
    const control = this.formGroup.get('userHandle');
    control?.setValue(actualValue, { emitEvent: false });
    control?.markAsTouched();
    const newCursorPosition = needsAtPrefix ? value.length : Math.max(1, cursorPosition);
    input.setSelectionRange(newCursorPosition, newCursorPosition);
  }
  
  onUserHandleKeydown(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const cursorPosition = input.selectionStart || 0;
    if (
      (event.key === 'Backspace' || event.key === 'Delete') &&
      cursorPosition <= 1 &&
      input.value.startsWith('@')
    ) {
      event.preventDefault();
      return;
    }
    if (event.key === '@') {
      event.preventDefault();
      return;
    }
    if (event.key === 'Home') {
      event.preventDefault();
      input.setSelectionRange(1, 1);
      return;
    }
  }

  onScreenInputBlur(event: Event) {
    const input = event.target as HTMLInputElement;
    const trimmedValue = input.value.trim();
    if (input.value !== trimmedValue) {
        this.formGroup.get('screenName')?.setValue(trimmedValue);
    }
  }
  
  onUserHandleFocus(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    if (!input.value || input.value === '@') {
      input.value = '@';
      input.setSelectionRange(1, 1);
    }
    setTimeout(() => {
      const cursorPosition = input.selectionStart || 0;
      if (cursorPosition < 1) {
        input.setSelectionRange(1, 1);
      }
    });
  }
  
  onUserHandleBlur(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    if (input.value === '@') {
      input.value = '';
      this.formGroup.get('userHandle')?.setValue('', { emitEvent: false });
    }
  }
  
  getUserHandleDisplayValue(): string {
    const val = this.formGroup.get('userHandle')?.value || '';
    return val ? `@${val}` : '';
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    this.file = event.target.files[0];
    if (this.file) {
      reader.readAsDataURL(this.file);
      reader.onload = () => {
        this.imageUrl = reader.result;
      };
    }
  }

  updateFile(event: any) {
    const userId = localStorage.getItem('userId');
    const reader = new FileReader();
    const originalFile = event.target.files[0];
    if (originalFile) {
      const renamedFile = new File([originalFile], `${userId}_thumbnail.jpg`, {
        type: originalFile.type
      });
      this.file = renamedFile;
      reader.readAsDataURL(this.file);
      reader.onload = () => {
        this.imageUrl = reader.result;
      };
    }
  }

  get f() {
    return this.formGroup.controls;
  }

  isFormChanged(): boolean {
    return (
      this.formGroup.get('screenName')?.value !== this.initialFormValues.screenName ||
      this.formGroup.get('about')?.value !== this.initialFormValues.about
    );
  }

  canSubmit(): boolean {
    if (!this.formGroup.valid || this.isLoading) return false;
    return this.updateProfile ? this.isFormChanged() || !!this.file : !!this.file;
  }

  onSubmit() {
    if (!this.formGroup.valid) return;
    this.isLoading = true;
    if (!this.formGroup.value.userHandle) {
      this.userHandleError = true;
      this.isLoading = false;
      return;
    } else {
      this.userHandleError = false;
    }
    if (this.updateProfile) {
      const requestBody = {
        device_id: localStorage.getItem('deviceId'),
        screen_name: localStorage.getItem('screenName'),
        user_name: localStorage.getItem('userName'),
        description: localStorage.getItem('description'),
        tqr_user_id: localStorage.getItem('userId'),
        phone_number: localStorage.getItem('contact')
      };
      if (this.file) {
        this.uploadImage();
      }
      this.http.post(`${URLS.updateUser}?fb_token_id=''&device_id=${encodeURIComponent(requestBody.device_id)}&screen_name=${this.formGroup.value.screenName}&user_name=${encodeURIComponent(this.formGroup.value.userHandle)}&description=${encodeURIComponent(this.formGroup.value.about)}&tqr_user_id=${encodeURIComponent(requestBody.tqr_user_id)}&phone_number=${encodeURIComponent(requestBody.phone_number)}&device_type=web`, {})
        .subscribe((result: any) => {
          this.isLoading = false;
          if (result.message === 'success') {
            localStorage.setItem('screenName', this.formGroup.value.screenName);
            localStorage.setItem('userName', this.formGroup.value.userHandle);
            localStorage.setItem('description', this.formGroup.value.about);
            this.showSuccess('Profile Successfully Updated');
          }
        });
    } else {
      const requestObj = {
        user_name: `@${this.formGroup.value.userHandle}`,
        device_id: localStorage.getItem('deviceId'),
        device_type: 'web',
        screen_name: this.formGroup.value.screenName,
        description: this.formGroup.value.about,
        fbTokenId: '',
        preRegToken: localStorage.getItem('preRegToken')
      };

      this.authService.registerNewUser(requestObj).subscribe(
        (res) => {
          localStorage.setItem('token', res.token);
          localStorage.setItem('refreshToken', res.refreshToken);
          localStorage.setItem('screenName', res.data.screenName);
          localStorage.setItem('userName', res.data.userName);
          localStorage.setItem('userId', res.data.localUserId);
          localStorage.setItem('profileImage', res.data.profileImage);
          localStorage.setItem('description', res.data.description);
          localStorage.setItem('contact', res.data.email);
          localStorage.removeItem('new_number');
          localStorage.removeItem('preRegToken');
          localStorage.removeItem('fb_token');
          if (this.file) {
            this.uploadImage();
          }
          this.authService.isAuthenticatedSubject.next(true);
          this.isLoading = false;
          const redirectUrl = localStorage.getItem('redirectAfterLogin');
          localStorage.removeItem('redirectAfterLogin');
          if (redirectUrl && !redirectUrl.startsWith('/login')) {
            this.router.navigate(['/' + redirectUrl.replace(/^\/+/, '')], { replaceUrl: true });
          } else {
            const wlChannel = localStorage.getItem('wl_channel');
            const defaultRoute = wlChannel ? `/${wlChannel}/v` : '/v';
            this.router.navigate([defaultRoute], { replaceUrl: true });
          }
          },
        (err) => {
          this.isLoading = false;
          console.error('Error registering:', err);
        }
      );
    }
  }

  uploadImage() {
    if (this.file) {
      const formData = new FormData();
      formData.append('photo', this.file);
      formData.append('tqr_user_id', localStorage.getItem('userId'));
      this.authService.uploadUserProfileImage(formData).subscribe((res) => {
        localStorage.setItem('profileImage', res.img_name);
        this.isLoading = false;
      });
    }
  }

  showDeleteDialog() {
    const dialogRef = this.dialog.open(DeleteModalComponent, {
      data: {
        screenname: this.formGroup.value.screenName,
        profileImage: this.imageUrl
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result?.data?.delete) {
        this.deleteAccount();
      }
    });
  }

  deleteAccount() {
    this.isLoading = true;
    this.deleteService.deleteProfile().subscribe(
      (result) => {
        this.isLoading = false;
        if (result.message === 'success') {
          this.authService.logout();
        }
      },
      (error) => {
        this.isLoading = false;
      }
    );
  }

  showSuccess(message: string) {
    this.toastrService.showNotification('success', '', message, 3000);
  }

  goBack(){
    this.location.back();
  }
}
